import { createContextScope } from '@radix-ui/react-context';

const DATE_PICKER_NAME = "DatePicker";
const [createDatePickerContext, createDatePickerScope] = createContextScope(DATE_PICKER_NAME);
const [DatePickerProvider, useDatePickerContext] = createDatePickerContext(DATE_PICKER_NAME);

export { DatePickerProvider, createDatePickerScope, useDatePickerContext };
//# sourceMappingURL=datePickerContext.mjs.map
